export default __webpack_public_path__ + "static/media/trainings-course.85ea3fed.svg";